import { render, staticRenderFns } from "./PersonInformation.vue?vue&type=template&id=484e36ab"
import script from "./PersonInformation.vue?vue&type=script&lang=js"
export * from "./PersonInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports